import * as d3 from "d3";
import GeneralChart from "./GeneralChart";
import { CrainData } from "./shared/CrainD3Vis";
import { ScatterPlotControl } from "./shared/ScatterPlotControl";
import { getUpdatedMetrics, getUpdatedZ } from "./shared/utilities";
import store from '@/store/store'

export default class extends GeneralChart {
  typeCats = true;
  logMetricX = false;
  logMetricY = true;
  metricX = "recency";
  metricY = "size";
  queryUpdated = false;
  labelVisibility = false;

  constructor(svg, type, settings=null) {
    super(svg, type, settings);
    if(settings){
      this.metricX = settings.metricX;
      this.metricY = settings.metricY;
    }
  }
  setQuery(value, redraw=true) {
    super.setQuery(value);
    console.log("setting Query");
    if(redraw){
      this.draw();
    }
  }
  setColor(value, redraw=true) {
    super.setColor(value);
    console.log("setting Color");
    if(redraw){
      this.draw();
    }
  }
  setLogMetricX(value, redraw=true) {
    if (typeof value !== "boolean") {
      console.error("Value should be boolean:", value);
    }

    this.logMetricX = value;
    console.log("setting logmetricX");
    if(redraw){
      this.draw();
    }
  }
  setLogMetricY(value, redraw=true) {
    if (typeof value !== "boolean") {
      console.error("Value should be boolean:", value);
    }

    this.logMetricY = value;
    console.log("setting logmetricy");
    if(redraw){
      this.draw();
    }
  }
  setMetricX(value, redraw=true) {
    if (typeof value !== "string") {
      console.error("Value should be string:", value);
    }

    this.metricX = value;
    this.setLogMetricX(
      value === "size" || value === "origsize" || value === "filtsize"
    , false);
    console.log("setting metricX");
    if(redraw){
      this.draw();
    }
  }
  setMetricY(value, redraw=true) {
    if (typeof value !== "string") {
      console.error("Value should be string:", value);
    }

    this.metricY = value;
    this.setLogMetricY(
      value === "size" || value === "origsize" || value === "filtsize"
    , false);
    console.log("setting metricY");
    if(redraw){
      this.draw();
    }
  }
  setSortX(value, redraw=true) {
    // Not used => sortX and sortY are not used for scatterplot
    super.setSortX(value);
    console.log("setting sortX");
    if(redraw){
      this.draw();
    }
  }
  setSortY(value, redraw=true) {
    // Not used => sortX and sortY are not used for scatterplot
    super.setSortY(value);
    console.log("setting sortY");
    if(redraw){
      this.draw();
    }
  }
  setSortZ(value, redraw=true) {
    super.setSortZ(value);
    console.log("setting sortZ");
    if(redraw){
      this.draw();
    }
  }
  setNormalizeOverX(value, redraw=true) {
    super.setNormalizeOverX(value);
    console.log("setting normalizeoverX");
    if(redraw){
      this.draw();
    }
  }

  setTypeCats(value, redraw=true) {
    if (typeof value !== "boolean") {
      console.error("Value should be boolean:", value);
    }

    this.typeCats = value;
    console.log("setting TypeCats");
    if(redraw){
      this.draw();
    }
  }
  setDataLimit(value, redraw=true) {
    super.setDataLimit(value, redraw);
    console.log("setting Datalimit");
    if(redraw){
      this.draw();
    }
  }

  setLabelVisibility(value, redraw=true) {
    this.labelVisibility = value;
    console.log("setting label Visibility");
    if(redraw){
      this.draw(true);
    }
  }

  getPlotMetricData(){
    return {
      sortZOptions: this.sortZOptions,
      metricOptions: this.metricOptions,
      sizeRange: this.sizeRange,
      recencyRange: this.recencyRange
    }
  }

  async init(cData) {
    //document.getElementById("load-div-plot").classList.add("show");
    if (cData !== null && !this.queryUpdated) {
      this.queryUpdated = false;
      const svgElement = d3.select(cData.svgDiv);
      const crainData = cData.crainData;
      this.control = new ScatterPlotControl(svgElement, crainData, this.svg);
    } else {
      const svgElement = d3.select(this.svg);
      const crainData = new CrainData(this.query);
      return crainData.load(this.dataLimit).then(() => {
        //console.log("Scatterplot", crainData);
        this.control = new ScatterPlotControl(svgElement, crainData, this.svg);
      })
      .catch(error => {
        const svg = d3.select(this.svg);
        svg.selectAll('g#main').remove();
          //const svg = d3.select("#mySvg");
          // Append text element to the SVG
        svg.append('g').attr('id', 'main');
        svg.select('g#main')
          .append("text")
          .attr("x", svg.attr("width") / 2)
          .attr("y", svg.attr("height") / 2)
          .attr("text-anchor", "middle")
          .attr("dominant-baseline", "middle")
          .text("No Enough Data to draw :(");
      });
    }
  }

  // TODO:
  // AnalysisViews aren't using these callbacks anymore.
  // When they are removed from FocusView visualizations as well, they can also be deleted here
  async draw(reset = false, ctype, inputs) {

    //store.dispatch('loadAnimStart');
    store.dispatch('saveLoadingStep', "Drawing Scatterplot");
    //console.log("Draw Called with reset", reset);
    let cData = this.control !== undefined ? this.control : null;
    //console.log(cData);
    if (reset) {
      await this.init(cData);
    }

    if(inputs){
      //this.metricX = inputs.metricX;
      //this.metricY = inputs.metricY;
      //reset = true;
      console.log("updating existing chart Scatterlot")
    }
    else{
      console.log("drawing chart  Scatterlot")
    }
    // This check is mainly to prevent console errors when an automatic refresh is triggered in local development
    if (!this.control || !this.control.config) {
      console.warn("No config");
      return;
    }
    this.control.showTypeCatLabels = this.typeCats;
    this.control.showLabelVisibility = this.labelVisibility;
    this.control.config.color = this.color;
    this.control.config.normOverX = this.normalizeOverX;

    this.sortZOptions = getUpdatedZ(this.control.crainData.rawData.layers[2]);
    this.metricOptions = getUpdatedMetrics(this.control.crainData.processedData);
    this.sizeRange = this.control.crainData.getSizeRange();
    this.recencyRange = this.control.crainData.getRecencyRange();
    /*
    // TODO: Remove this when callbacks removed
    if (reset === true && resetCallback) {
      if (typeof resetCallback === "function") {
        resetCallback(getUpdatedZ(this.control.crainData.rawData.layers[2]));
      } else if (typeof resetCallback !== "function") {
        console.error("resetCallback should be function", resetCallback);
      }
    }

    // TODO: Remove this when callbacks removed
    if (reset === true && metricCallback) {
      //let um = getUpdatedMetrics(this.control.crainData.processedData);
      //console.log(um);
      if (typeof metricCallback === "function") {
        metricCallback(getUpdatedMetrics(this.control.crainData.processedData));
      } else if (typeof metricCallback !== "function") {
        console.error("resetCallback should be function", metricCallback);
      }
    }

    // TODO: Remove this when callbacks removed
    if (reset === true && rangeCallback) {
      if (typeof rangeCallback === "function") {
        rangeCallback(
          this.control.crainData.getSizeRange(),
          this.control.crainData.getRecencyRange(),
          true
        );
      } else if (typeof rangeCallback !== "function") {
        console.error("rangeCallback should be function", rangeCallback);
      }
    }
    */
    const metricX = `${this.metricX}_${this.logMetricX ? "log" : "linear"}`;
    const metricY = `${this.metricY}_${this.logMetricY ? "log" : "linear"}`;
    this.control.crainData.prep(
      this.sortZ,
      0,
      this.sortX,
      this.sortY,
      this.sizeLimit,
      this.recencyLimit
    );
    this.control.update(reset, reset, metricX, metricY);
  }
}